
export const d1 =
`
Great, we have a DAG that tells about how each variable relates to each other. Now what?

Fortunately most of the heavy lifting is already done. If you have designed the DAG properly, the next part will be 
quit simple. The key is to make sure that for any node, there are no more than 2 children that point *to* it. 
With this assumption, we can move on to the next part.
`.trim();



export const d2 =
`
In reverse mode autodiff, the gradients are calculated backwards; i.e. the gradient for the "last" variable in the 
DAG (like say the loss) is set to 1 (since gradient of los w.r.t. loss is obviously 1), and follow this algorithm:

\`\`\`
for every child X of Z:
    X' := X' + (Z' * dZ/dX)
\`\`\`

Essentially, we know the value of \`Z'\`, and the value of \`dZ/dX\` can be found for primitive operators, 
**which only depends on the values of children of Z**. When the gradient is calculated for these intermediary 
variables, it is called the "Adjoint". The formula in the diagram is the same thing, stated for each variable 
instead of in terms of the parent.
`.trim();




export const d3 =
`
If you go through that, good job because that essentially covers most of it. What remains are some miscellaneous things 
such is matrix operations, but other than that you can now write your own autodiff engine. Though you should probably just use 
pytorch or something.
`.trim();




export const mat1 =
`
For element-wise matrix operations (like +, -, etc) the above discussion covers it. What about matrix multiplication? 
How do we deal with changing matrix dimensions? 

I'm happy to report that nothing really changes, all you need to do is think in terms of \`z = f(x, y)\`. 
As long as you can describe dz/dx and dz/dy, it will just work. For eg., with matrix multiplication:

`.trim();

//matmul diagram

export const mat2 =
`
All you need to do is keep track of the relevant dimensions and think about how the gradient needs to flow 
backwards from this operation. For more examples, look through the code in [picograd](https://github.com/StealthyPanda/picograd).

`.trim();



export const eager =
`
If you go through [picograd](https://github.com/StealthyPanda/picograd), you'll see that the value of a tensor is calculated at the same time as 
it is created. This was a design choice, and is not necessarily the only way to do it. Tensor that behave like this are called "eager tensors" and was the simplest way to 
implement this, but this isn't the only way. You can also store an "empty" computational graph, and then 
calculate the value of each node only when it is needed for some other computation. This is called "lazy" evaluation, and tensorflow follows this 
by default. Again, you can try to implement lazy tensors, though the complexity increases quickly.

`.trim();



